







































import { Facet, Filter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { GetFacetConfigByName } from '../../../store/config/getters/facet.getter';
import { GETTERS_KEYS } from '../../../store/store.const';
import { VueCssClasses } from '../../../utils';
import { AnimateSizeToAuto } from '../utils';

@Component({
  directives: {
    focus: {
      inserted: el => el.focus()
    }
  }
})
export default class DefaultFacet extends Vue {
  protected query = '';
  protected searchToggled = false;

  @Prop({ required: true })
  facet: Facet;

  @Prop({ required: true })
  facetGroup: string;

  @Prop({ default: false })
  searchable: boolean;

  @Prop({ default: true })
  collapsible: boolean;

  @Prop({ default: true })
  collapsed: boolean;

  @Prop({ default: true })
  animations: boolean;

  @Prop({ default: false })
  showMoreButton: boolean;

  @Prop({ default: 5 })
  filtersToShow: number;

  @Prop({ required: true })
  compulsory: boolean;

  showFilters = false;
  showSearchBox = false;

  animateHeightToAuto = new AnimateSizeToAuto();

  get title(): string {
    return this.$x.messages.facets.titles[this.facet.modelName] as string || this.facet.title;
  }

  get matchingFilters(): Filter[] {
    return this.facet.filters.filter(filter => filter.title.match(this.filterRegex));
  }

  get filterRegex(): RegExp {
    const facetsFilterRegex = this.$options.filters.compileMessage(
      this.facetConfig.searchable.facetsFilterRegex, { query: this.query });
    return new RegExp(facetsFilterRegex, 'i');
  }

  get facetConfig() {
    const getFacetConfig: GetFacetConfigByName = this.$store.getters[GETTERS_KEYS.config.facet];
    return getFacetConfig(this.facet.modelName, this.facetGroup);
  }

  get filters(): Filter[] {
    if (this.showMoreButton && this.matchingFilters && !this.showFilters) {
      return this.matchingFilters.slice(0, this.filtersToShow);
    } else {
      return this.matchingFilters;
    }
  }

  get hasFilterSelected(): boolean {
    return !!this.facet.filters.find(filter => filter.selected);
  }

  get renderShowMoreButtons(): boolean {
    return this.showMoreButton && this.matchingFilters && this.filtersToShow < this.matchingFilters.length;
  }

  get hiddenFiltersNumber(): number {
    return this.matchingFilters.length - this.filtersToShow;
  }

  get cssClasses(): VueCssClasses {
    return [
      `ebx-facet--${ this.facet.modelName }`,
      {
        'ebx-facet--collapsed': this.collapsed,
        'ebx-facet--compulsory': this.compulsory,
        'ebx-facet--selected': this.hasFilterSelected,
        'ebx-facet--searchable': this.searchable,
        'ebx-facet--open-search': this.showSearchBox,
        'ebx-facet--search-toggled': this.searchToggled
      }
    ];
  }

  toggledSearch(newState: boolean) {
    return this.searchToggled = newState;
  }

  queryUpdated(query: string) {
    this.query = query;
  }

  toggleCollapse() {
    if (this.collapsible) {
      this.$x.emit(EVENTS.SetFacetCollapse,
        { facetGroup: this.facetGroup, facetName: this.facet.modelName, collapsed: !this.collapsed });
    }
  }

  onShowMoreClick() {
    this.showFilters = true;
  }

  onShowLessClick() {
    this.showFilters = false;
  }
}
